
const { registerBlockType } = wp.blocks;
const { InspectorControls } = wp.editor;
import { PanelBody } from '@wordpress/components';
import React, { useState, useEffect } from 'react';
import Parser from "html-react-parser";

//custom components
import ProductId from "./controls/productid";
import ButtonText from "./controls/buttontext";
import TriggerProduct from "./controls/triggerproduct";
import AllowSingle from "./controls/allowsingle";

const { Component } = wp.element;

registerBlockType('migblocks/overlay-product', {
    title: 'Gumroad Overlay Product',
    icon: 'store',
    category: 'apijoin-gumroad',
    attributes: {
        productId: {
            type: "string",
            default: ""
        },
        buttonText: {
            type: "string",
            default: "Buy Now"
        },
        triggerProduct: {
            type: "boolean",
            default: false
        },
        allowSingle: {
            type: "boolean",
            default: false
        },
    },



    edit: class extends Component {
        constructor(props) {
            super(props);



        }
        componentDidMount(props){
         
        }


        render() {


            const { attributes: { productId, buttonText, triggerProduct, allowSingle}, setAttributes } = this.props;

          
            let triggerCheck = "";
            if(triggerProduct == true){
                triggerCheck = "?wanted=true";
            }

            let allowSingleCheck = "";
            if(allowSingle == true){
                allowSingleCheck = "data-gumroad-single-product=\"true\"";
            }

            let content = "";
            content += `<a class="gumroad-button" href="https://gum.co/${productId}${triggerCheck}" target="_blank" ${allowSingleCheck} rel="noopener noreferrer">`;
            content += buttonText;
            content += `</a>`;

            if(productId){
                return (
                    <React.Fragment>
                        <InspectorControls>
                            <PanelBody title={"Product Options"} initialOpen={true} >
                                
                                <ProductId {...this.props}/>
                                <ButtonText {...this.props}/>
                                <TriggerProduct {...this.props}/>
                                <AllowSingle {...this.props}/>
    
                                
                            </PanelBody>
                        </InspectorControls>

                        {Parser(content)}
                    </React.Fragment> 
                );
            }

            return (
                <React.Fragment>
                    <InspectorControls>
                        <PanelBody title={"Product Options"} initialOpen={true} >
                            
                            <ProductId {...this.props}/>
                            <ButtonText {...this.props}/>
                            <TriggerProduct {...this.props}/>
                            <AllowSingle {...this.props}/>

                            
                        </PanelBody>
                    </InspectorControls>

                    <h2 className="apijoin-nogumroad-id">
                        Insert a Product ID
                    </h2>

                </React.Fragment> 
           
            );


        }
    },

    save: class extends Component {

        constructor(props) {
            super(props);

        }



        render() {
            const { attributes: { productId, buttonText, triggerProduct, allowSingle }} = this.props;

            let triggerCheck = "";
            if(triggerProduct == true){
                triggerCheck = "?wanted=true";
            }

            let allowSingleCheck = "";
            if(allowSingle == true){
                allowSingleCheck = "data-gumroad-single-product=\"true\"";
            }

            let content = "";
            content += `<a class="gumroad-button" href="https://gum.co/${productId}${triggerCheck}" target="_blank" ${allowSingleCheck} rel="noopener noreferrer">`;
            content += buttonText;
            content += `</a>`;
            
            return (

                
                <React.Fragment> 
                    {Parser(content)}
                </React.Fragment> 
            );
        }





    }


});
